import { Blue } from "@traceair/tds";
import React, { memo } from "react";
import type { IconProps } from "./_IconProps";

const Copy = ({ color = Blue }: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 2C21.8284 2 22.5 2.67157 22.5 3.5V16.5C22.5 17.3284 21.8284 18 21 18H8C7.17157 18 6.5 17.3284 6.5 16.5V3.5C6.5 2.67157 7.17157 2 8 2H21ZM18.5 21C18.5 21.55 18.05 22 17.5 22H4.5C3.4 22 2.5 21.1 2.5 20V7C2.5 6.45 2.95 6 3.5 6C4.05 6 4.5 6.45 4.5 7L4.5 19C4.5 19.55 4.95 20 5.5 20H17.5C18.05 20 18.5 20.45 18.5 21Z"
        fill={color}
      />
    </svg>
  );
};

export default memo(Copy);
